/**
 * Public YouTube videos for the marketing site.
 * IDs are used with youtube-nocookie embeds (consent-gated in DemoVideo).
 */
export const IMPROVE_VIDEOS = {
  home: {
    id: 'k-n_4_XvsCY',
    title: 'Why IMPROVE Exists',
    subtitle: 'See why IMPROVE was built for growing businesses.',
    url: 'https://youtu.be/k-n_4_XvsCY',
  },
  features: {
    id: '4PPNODjEk_Y',
    title: 'How IMPROVE Works',
    subtitle: 'A clear walkthrough of the platform in action.',
    url: 'https://youtu.be/4PPNODjEk_Y',
  },
  library: {
    id: 'isf-D3QHepw',
    title: 'Explore the Learning Library',
    subtitle: 'Browse the courses available to every subscription.',
    url: 'https://youtu.be/isf-D3QHepw',
  },
  leadership: {
    id: 'MBjEWDDiiLk',
    title: 'Why Leadership Plus Exists',
    subtitle: 'Develop future managers with the Leadership Plus bolt-on.',
    url: 'https://youtu.be/MBjEWDDiiLk',
  },
  compare: {
    id: 'rZLU0HPtx-I',
    title: 'Compare Before You Decide',
    subtitle: 'See how IMPROVE compares before you buy.',
    url: 'https://youtu.be/rZLU0HPtx-I',
  },
  pricing: {
    id: 'NQtCzVAsuEo',
    title: 'Simple Pricing',
    subtitle: 'One price per business — no hidden extras.',
    url: 'https://youtu.be/NQtCzVAsuEo',
  },
  stories: {
    id: 'AtIHYpFkbBY',
    title: 'Why Customers Choose IMPROVE',
    subtitle: 'Hear why growing businesses trust IMPROVE.',
    url: 'https://youtu.be/AtIHYpFkbBY',
  },
  about: {
    id: 'K6_EMrGaPp0',
    title: 'Why I Started IMPROVE',
    subtitle: 'The story behind IMPROVE.',
    url: 'https://youtu.be/K6_EMrGaPp0',
  },
};

export function getImproveVideo(key) {
  return IMPROVE_VIDEOS[key] || null;
}
